import React from 'react';
import {
    Link
} from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import ChatBot from 'react-simple-chatbot';
import LoadingBar from 'react-top-loading-bar';
import {
    Container,
    Title,
    Description,
    Content,
    NewLine,
    BotTheme,
    Point
} from './style';
import { Conversation } from './conversation';


class eCommerceChatbot extends React.Component {
    state = {
        loadingBarProgress: Math.random() * 100
    };

    complete = () => {
        this.setState({ loadingBarProgress: 100 });
    };

    onLoaderFinished = () => {
        this.setState({ loadingBarProgress: 0 });
    };

    componentDidMount() {
        this.complete();
    }

    render() {
        // const isMobile = window.innerWidth < 480;

        return (
            <Container>
                <LoadingBar
                    progress={this.state.loadingBarProgress}
                    height={3}
                    color='#fff'
                    onLoaderFinished={() => this.onLoaderFinished()}
                />
                <Link to="/"><Title> {"{"} nightbot.dev {"}"} </Title></Link>
                <Description> Online Store Chatbot </Description>
                <Content>
                    <Point>Case Study:</Point>
                    <NewLine />
                    You are the owner of Wood'n Decor, a fictional carpentry workshop which specializing in creating awesome wall decorations. You already have the online store to sell your products, but you want to have more user interaction in your website in order to increase the engagement rate, by adding a chatbot.
                    <NewLine />
                    <NewLine />
                    <Point>Feature(s):</Point>
                    <NewLine />
                    Product Searching &middot; Order Tracking
                    <NewLine />
                    <NewLine />
                    <Point>How-To:</Point>
                    <NewLine />
                    Click the chat icon on the bottom right of the page, and you will be able to talk to the Wood'n Decor chatbot.
                    <NewLine />
                    This chatbot will suggest Etsy products in the end of the conversation (resembling your own online store). No affiliate link is placed, so feel free to click it if you want to.
                    <NewLine />
                    For the tracking code, you can enter any number you like.
                </Content>

                <ThemeProvider theme={BotTheme}>
                    <ChatBot
                        steps={Conversation}
                        floating={true}
                        opened={false}
                        headerTitle="Wood'n Decor Bot"
                        hideBotAvatar={true}
                        hideUserAvatar={true}

                        style={{
                            marginTop: "30px",
                            marginLeft: "auto",
                            marginRight: "auto",
                            letterSpacing: "0.1em",
                            fontWeight: "lighter"
                        }}
                    />
                </ThemeProvider>
            </Container>
        )
    }
}

export default eCommerceChatbot;